import { useState } from "react";
import { MdOutlineLock, MdOutlineVisibility, MdOutlineVisibilityOff } from "react-icons/md";

import "./InputSenha.css";

const InputSenha = ({ 
  placeholder, 
  onChange, 
  tipoInput, 
  erro, 
  onKeyDown, 
  icone // nova prop para customizar o ícone
}) => {

  const [exibeSenha, setExibeSenha] = useState(false);
  const [valorInput, setValorInput] = useState("");

  const handleInputChange = (e) => {
    const { value } = e.target;
    setValorInput(value);
    onChange(value);
  };

  const toggleExibeSenha = () => setExibeSenha(!exibeSenha);

  return (
    <div
      className={`
      container-input-senha 
      ${erro ? "erro-invalido" : ""}
      ${valorInput.length > 0 ? "container-input-senha-preenchido" : ""}
    `}>
      
      {/* Renderiza o ícone customizado se fornecido, senão usa o padrão */}
      {icone ? (
        <span className="icone-input-senha-custom">{icone}</span>
      ) : (
        <MdOutlineLock className={`
          icone-input-senha
          ${valorInput.length > 0 ? "icone-input-senha-preenchido" : ""}
        `} />
      )}

      <input
        className={`input-senha`}
        type={exibeSenha ? "text" : "password"}
        placeholder={placeholder}
        onChange={(e) => handleInputChange(e)}
        onKeyDown={onKeyDown}
      />

      <div
        className="container-icone-exibe-senha"
        onClick={toggleExibeSenha}
        title={exibeSenha ? "Esconder senha" : "Exibir senha"}
      >
        {exibeSenha ? (
          <MdOutlineVisibility className={"icone-esconde-senha"} />
        ) : (
          <MdOutlineVisibilityOff className={"icone-exibe-senha"} />
        )}
      </div>
    </div>
  );
};
 
export default InputSenha;